import { render, staticRenderFns } from "./SearchTemplateFilters.vue?vue&type=template&id=32a28b4c&scoped=true&"
var script = {}
import style0 from "./SearchTemplateFilters.vue?vue&type=style&index=0&id=32a28b4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a28b4c",
  null
  
)

export default component.exports